import React from 'react';
import NavBar from './NavBar.jsx';

import ReactDOM from 'react-dom';
import ContextList from './contextList.jsx'
import UsersList from './userList.jsx';
import CompositionsList from './CompositionList.jsx';
import PrefabAudioList from './PrefabAudioList.jsx';
import TestAPI from './TestAPI.jsx';
import TagsList from "./TagsList.jsx";
import PlaylistList from './playlistList.jsx';
import Account from './Account.jsx';
import BreadCrumb from './BreadCrumb.jsx';

class Admin extends React.Component {
   constructor(props)
   {
      super(props);

      this.state = new Object();
      this.state.page = "";
      this.state.crumbs = [];

      this.changePageCallback = function(pageElem, addToCrumb = true)
      {
         if(addToCrumb)
         {
             var newCrumb = this.state.crumbs;
            newCrumb.push(pageElem);
            this.setState({crumbs:newCrumb});
         }

         this.setState({page:pageElem});
         /*
         var newNavBarState = new Object();

         newNavBarState.currentBtn = newPage;
         
         this.setState({navBarState:newNavBarState});
         
         this.state.navBarState.currentBtn = newPage;
         */
      }.bind(this);

      this.clickedCrumbCB = function(depth)
      {
         var newCrumb = this.state.crumbs;
         
         var firstIndexToRemove = depth + 1;

         newCrumb.splice(firstIndexToRemove, newCrumb.length - firstIndexToRemove);

         this.setState({crumbs:newCrumb});

         this.changePageCallback(newCrumb[depth], false);

         //console.log("clicked crumb depth: " + depth);
      }.bind(this);

      console.log("ADMIN Constr.")
   }

   componentDidMount()
   {
      //var startUpload = {id:"uploadAudio", name:'Upload Audio'};
      var startPageAccount = {id:"account", name:'Account'};
      var startPageContexts = {id:"contexts", name:'Contexts'};
      var startPageUsers = {id:"users", name:'Users'};
      this.changePageCallback(startPageAccount);
   }

   render()
   {
      //console.log("Render admin");
      var pageSplitParentStyle =
      {
        //border: 'solid 1px #ff0000',
         
         //margin: '20px 0px 0px 0px',
         listStyle: 'none',
         //height:600,
         padding: 0,
         minWidth:800,
      }

      var pageSplitNavBarStyle ={
         //border: 'solid 1px #00ff00',
         verticalAlign:'top',
         display: 'inline-block',
         //margin: '30px auto',
         //padding: 0,
         height: '100%',
      }

      var pageSplitContentStyle ={
        // border: 'solid 1px #0000ff',
         verticalAlign:'top',
         display: 'inline-block',
         margin: '0 0 0 30px',
         padding: 0,
         //overflowY: "scroll",
      }

      return (
         <div>

            <BreadCrumb crumbs={this.state.crumbs} clickedCrumb = {this.clickedCrumbCB}/>

            <div style ={pageSplitParentStyle}>
              
               <div style = {pageSplitContentStyle}>
                  {this.state.page.id != "contexts" ? null :
                  <ContextList
                     user={this.props.user}
                     appCallbacks = {this.props.appCallbacks}
                     changePageCallback={this.changePageCallback} pageData={this.state.page}/> }

                  {this.state.page.id != "account" ? null :
                  <Account
                     appCallbacks = {this.props.appCallbacks} user={this.props.user}
                     changePageCallback = {this.changePageCallback} pageData={this.state.page}/> }

                  {this.state.page.id != "testAPI" ? null :
                  <TestAPI
                     appCallbacks = {this.props.appCallbacks}
                     changePageCallback = {this.changePageCallback} pageData={this.state.page}/> }

                  {/*this.state.page.id != "uploadAudio" ? null :
                  <UploadAudio user={this.props.user}
                     appCallbacks = {this.props.appCallbacks}
                     changePageCallback = {this.changePageCallback} pageData={this.state.page}/> */}

                  {this.state.page.id != "users" ? null :
                  <UsersList
                     user={this.props.user}
                     appCallbacks = {this.props.appCallbacks}
                     changePageCallback = {this.changePageCallback} pageData={this.state.page}/> }

                  {this.state.page.id != "compositions" ? null :
                  <CompositionsList user={this.props.user}
                     appCallbacks = {this.props.appCallbacks}
                     changePageCallback = {this.changePageCallback} pageData={this.state.page}/> }

                  {this.state.page.id != "playlists" ? null :
                  <PlaylistList
                     appCallbacks = {this.props.appCallbacks} user={this.props.user}
                     changePageCallback = {this.changePageCallback} pageData={this.state.page}/>}

                  {this.state.page.id != "tags" ? null :
                  <TagsList
                     appCallbacks = {this.props.appCallbacks} user={this.props.user}
                     changePageCallback = {this.changePageCallback} pageData={this.state.page}/>}

                  {this.state.page.id != "prefabAudio" ? null :
                  <PrefabAudioList
                     appCallbacks = {this.props.appCallbacks} user={this.props.user}
                     changePageCallback = {this.changePageCallback} pageData={this.state.page}/>}
               </div>
            </div>
         </div>
      );
      
   }
}

export default Admin;


// WEBPACK FOOTER //
// ./js/Admin.jsx